import { render, staticRenderFns } from "./recap_body.vue?vue&type=template&id=57d19411&"
import script from "./recap_body.vue?vue&type=script&lang=js&"
export * from "./recap_body.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports